"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var provider;
        (function (provider) {
            var integrations;
            (function (integrations) {
                class InitArgs {
                    constructor() {
                        this.addSendGridDomainLink = appn.emptyString;
                        this.deleteSendGridDomainAuth = appn.emptyString;
                        this.showDnsRecordDialogLink = appn.emptyString;
                        this.removeBimi = appn.emptyString;
                        this.testAiConfig = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTableApiLogs = null;
                let _initialSendGridRegion = appn.emptyString;
                function init(args) {
                    _initArgs = args;
                    _initialSendGridRegion = $('#Provider_ProviderConfig_SendGridRegion').val();
                    addEvents();
                    createDataTableApiLogs();
                    appn.select.init({
                        selector: 'select.formatType',
                        omitWidth: true
                    });
                }
                integrations.init = init;
                function addEvents() {
                    $('.connectorOption').on('click', function () {
                        if ($(this).data('upgrade-required')) {
                            $('#upgradeReqd').modal('show');
                            return;
                        }
                        const form = $('form#appnForm');
                        form.append('<input type="hidden" name="submitType" value="' + $(this).attr('id') + '" />');
                        form.submit();
                    });
                    $('#addConnector').on('click', function () {
                        $('#connectorsDialog').modal('show');
                    });
                    $('.btn-enableDisableSso').on('click', function (event) {
                        event.preventDefault();
                        const isSsoEnableElement = $('#Provider_ProviderConfig_IsSsoEnabled');
                        const currentValue = isSsoEnableElement.val();
                        if (currentValue.containsIgnoreCase('False'))
                            isSsoEnableElement.val('True');
                        else
                            isSsoEnableElement.val('False');
                        const form = $('form#appnForm');
                        form.append('<input type="hidden" name="submitType" value="Save" />');
                        form.submit();
                    });
                    $('#apiLogsBtn').off().on('click', function () {
                        $('#apiLogsDialog').modal('show');
                        appn.dataTable.redrawOnResize(300);
                    });
                    $('.addHeader').each(function () {
                        const addLink = $(this);
                        addLink.click(function () {
                            const newRowIdx = (new Date()).getTime();
                            let templateHtml = $('#RESTHeaderRowTemplate').html();
                            templateHtml = templateHtml.replace(/Headers\[0\]/g, 'Headers[' + newRowIdx + ']')
                                .replace(/Headers_0__/g, 'Headers_' + newRowIdx + '__');
                            const container = $(this).closest('.custom-headers').find('.headerRowsContainer');
                            const newRow = $(templateHtml);
                            newRow.find('input').val('');
                            newRow.find('.rowIndexer').val(newRowIdx);
                            bindDeleteHeaderBtn(newRow.find('.delete_button'));
                            container.append(newRow);
                        });
                    });
                    $('.headerRow .delete_button').each(function () {
                        bindDeleteHeaderBtn($(this));
                    });
                    $('.add-custom-headers').on('click', function () {
                        const dts = $('.custom-headers');
                        dts.showElement();
                        dts.removeClass('d-none');
                        dts.find('.addHeader').trigger('click');
                        $('.add-custom-headers').hideElement();
                    });
                    $('.add-custom-body').on('click', function () {
                        const dts = $('.customBody');
                        dts.showElement();
                        dts.removeClass('d-none');
                        $('.add-custom-body').hideElement();
                    });
                    $('.testLink').on('click', function () {
                        $('#testAuthDialog').modal('show');
                    });
                    $('#testForm').submit(function (event) {
                        event.preventDefault();
                        $('#testAuthDialog').modal('hide');
                        const form = $(this);
                        appn.ajax.post({
                            url: form.attr('action'),
                            data: $('#externalAuthREST :input, #testForm').serialize(),
                            dataType: 'json',
                            done: function (data) {
                                appn.dialog.hideLoading();
                                if (data.success === 'True') {
                                    appn.toast.notify(appn.toast.Type.info, T('Authentication successful'));
                                    return;
                                }
                                appn.toast.notify(appn.toast.Type.error, data.responseText);
                            },
                            fail: function () {
                                appn.dialog.hideLoading();
                            }
                        });
                    });
                    $('.btn-regenIntegrationKey').on('click', function (e) {
                        e.preventDefault();
                        const closestInputGroup = $(this).closest('.input-group').find('input');
                        const thisKeyName = $(this).closest('.form-group').find('label span span').text();
                        appn.dialog.confirm({
                            modalColor: 'modal-warning',
                            title: T('Regenerate Access Key'),
                            message: T('This action will reset <b>{0}</b> to a new value.<br><br>Any API requests using the above Key value will fail after regeneration, which may cause issues for API integrations with our platform.<br><br><b>Ensure that your API integrations are using the other available Key before proceeding.</b>', thisKeyName),
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success'
                                }
                            },
                            callback: function (result) {
                                if (result) {
                                    appn.dialog.showLoading();
                                    closestInputGroup.val('');
                                    const form = $('form#appnForm');
                                    form.append('<input type="hidden" name="submitType" value="regenKEYNAME" />'.replace('KEYNAME', thisKeyName));
                                    form.submit();
                                }
                            }
                        });
                    });
                    $('.editSecretKey').click(function (event) {
                        event.preventDefault();
                        const connectionCard = $(this).closest('.card');
                        connectionCard.find('.maskedSecretKey').hide();
                        connectionCard.find('.editSecretKey').hide();
                        connectionCard.find('.input-secretkey').fadeIn();
                    });
                    $('.addSendGridDomainItem').on('click', function (event) {
                        event.preventDefault();
                        addSendGridDomain(_initArgs.addSendGridDomainLink);
                    });
                    $(document).on('click', '.delete_button_sendGridDomainAuth', function (event) {
                        event.preventDefault();
                        let row = $(this).closest('tr');
                        let table = $(this).closest('table');
                        let domainName = row.find('[id$="DomainName"]').val();
                        let domainId = row.find('[id$="DomainId"]').val();
                        if (!appn.utils.hasValue(domainId)) {
                            row.remove();
                            renameRows();
                            if (table.find('tbody tr').length === 0)
                                table.hideElement();
                            $('.addSendGridDomainItem').showElement();
                            return;
                        }
                        appn.dialog.custom({
                            modalColor: 'modal-danger',
                            title: T(`Delete Domain {0}?`, domainName),
                            message: T(`You are about to permanently delete the domain named {0}. <br><br>Hit the <b>Delete</b> button to proceed.`, domainName),
                            isDeleteAction: true,
                            closeButton: true,
                            buttons: {
                                trash: {
                                    label: '<span>' + T('Delete') + '</span>',
                                    className: 'btn-danger',
                                    callback: function (result) {
                                        if (result) {
                                            appn.ajax.post({
                                                url: _initArgs.deleteSendGridDomainAuth,
                                                dataType: 'json',
                                                data: {
                                                    domainId: domainId
                                                },
                                                done: function () {
                                                    row.remove();
                                                    renameRows();
                                                    if (table.find('tbody tr').length === 0)
                                                        table.hideElement();
                                                    appn.location.reloadCurrentPage();
                                                },
                                                fail: function () {
                                                    appn.toast.notify(appn.toast.Type.error, T('Failed to delete domain.'));
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                        });
                    });
                    $(document).on('click', '.btn-showVerifyDialog', function (event) {
                        event.preventDefault();
                        let domainId = $(this).closest('tr').find('[id$="DomainId"]').val();
                        showVerifySendGridDomain(_initArgs.showDnsRecordDialogLink, domainId);
                    });
                    $(document).on('click', '.btn-remove', function () {
                        let button = $(this);
                        let row = button.closest('tr');
                        let domainId = row.find('[id$="DomainId"]').val();
                        appn.ajax.post({
                            url: _initArgs.removeBimi,
                            dataType: 'json',
                            data: {
                                domainId: domainId,
                            },
                            done: function () {
                                button.hideElement();
                                appn.location.reloadCurrentPage();
                            },
                            fail: function () {
                                appn.toast.notify(appn.toast.Type.error, T('Failed to delete BIMI image'));
                            }
                        });
                    });
                    $('#Provider_ProviderConfig_SendGridRegion').on('change', function () {
                        const $dropdown = $(this);
                        const newRegion = $dropdown.val();
                        if (newRegion !== _initialSendGridRegion) {
                            const regionLabel = newRegion === 'EU' ? 'EU' : 'US';
                            appn.dialog.confirm({
                                modalColor: 'modal-warning',
                                title: T('Switching SendGrid API Regions?'),
                                message: T('Make sure to generate and paste a new API key from your SendGrid {0} subuser dashboard, or your emails will fail to send.', regionLabel),
                                buttons: {
                                    confirm: {
                                        label: '<span>' + T('Switch Region') + '</span>',
                                        className: 'btn-success'
                                    }
                                },
                                callback: function (result) {
                                    if (result) {
                                        _initialSendGridRegion = newRegion;
                                        const form = $('form#appnForm');
                                        form.append('<input type="hidden" name="submitType" value="Save" />');
                                        form.submit();
                                    }
                                    else {
                                        $dropdown.val(_initialSendGridRegion).trigger('change');
                                    }
                                }
                            });
                        }
                    });
                    $('input[id$="EmailServiceApiKey"]').on('input change', function () {
                        const hasApiKey = $(this).val().trim().length > 0;
                        const $regionWrapper = $('#SendGridRegionWrapper');
                        if (hasApiKey) {
                            $regionWrapper.show();
                        }
                        else {
                            $regionWrapper.hide();
                            $('#Provider_ProviderConfig_SendGridRegion').val(_initialSendGridRegion).trigger('change');
                        }
                    });
                    $('#Provider_ProviderConfig_AiConfig_FeaturesEnabled').on('change', function () {
                        if ($(this).is(':checked'))
                            $('.aiConfig').showElement();
                        else
                            $('.aiConfig').hideElement();
                    });
                    const $aiModelSelect = $('#Provider_ProviderConfig_AiConfig_ModelName');
                    const $aiRegionRow = $('#aiRegionRow');
                    const $aiRegionSelect = $('#Provider_ProviderConfig_AiConfig_Region');
                    $('#Provider_ProviderConfig_AiConfig_CustomUrl').on('change', function () {
                        if ($aiModelSelect.find('option:selected').data('model-provider') !== "OpenAI")
                            return;
                        if (appn.utils.hasValue($(this).val()))
                            $aiRegionRow.hideElement();
                        else
                            $aiRegionRow.showElement();
                    });
                    $('#Provider_ProviderConfig_AiConfig_ApiKey, #aiServiceKey').on('change', function () {
                        $('.btn-aiTest').addClass('disabled');
                        $('#aiTestStatus').text(T(`Save Configuration before testing.`));
                    });
                    function updateRegionDropdown() {
                        const $selectedOption = $aiModelSelect.find('option:selected');
                        const regions = $selectedOption.data('regions') || '';
                        if (regions) {
                            const currentRegion = $aiRegionSelect.val();
                            $aiRegionSelect.empty();
                            regions.split(',').forEach(function (r) {
                                const $opt = $('<option></option>').val(r).text(r);
                                if (r === currentRegion || (!currentRegion && r === regions.split(',')[0]))
                                    $opt.prop('selected', true);
                                $aiRegionSelect.append($opt);
                            });
                            $aiRegionRow.showElement();
                        }
                        else {
                            $aiRegionSelect.empty();
                            $aiRegionRow.hideElement();
                        }
                    }
                    $aiModelSelect.on('change', function () {
                        updateRegionDropdown();
                        $('#anthropicUnsupportedFeatures').toggleClass('d-none', $(this).find('option:selected').data('model-provider') !== 'Anthropic');
                        if ($(this).val() === appn.emptyString) {
                            $('#aiApiKey').hideElement();
                            $('#aiServiceKey').hideElement();
                            $('#aiCustomUrl').hideElement();
                            $('#aiTestRow').hideElement();
                            return;
                        }
                        $('#aiTestRow').showElement();
                        if ($(this).find('option:selected').data('model-provider') === 'GoogleAgentPlatform') {
                            $('#aiApiKey').hideElement();
                            $('#aiServiceKey').showElement();
                            $('#aiCustomUrl').hideElement();
                        }
                        else {
                            $('#aiApiKey').showElement();
                            $('#aiServiceKey').hideElement();
                            $('#aiCustomUrl').showElement();
                        }
                    });
                    $('.btn-aiTest').on('click', function () {
                        const resultMessage = $('#aiTestStatus');
                        appn.ajax.post({
                            url: _initArgs.testAiConfig,
                            data: {
                                modelName: $aiModelSelect.val(),
                                customUrl: $('#aiCustomUrl input').val(),
                                region: $('#aiRegionRow select').val()
                            },
                            dataType: 'json',
                            done: function (data) {
                                resultMessage.toggleClass("text-danger", !data.Success);
                                resultMessage.toggleClass("text-success", data.Success);
                                resultMessage.text(data.Message);
                            },
                            fail: function () {
                                resultMessage.toggleClass("text-danger", true);
                                resultMessage.toggleClass("text-success", false);
                                resultMessage.text(T('An error occurred while testing the AI configuration.'));
                            }
                        });
                    });
                    $aiModelSelect.trigger('change');
                }
                function createDataTableApiLogs() {
                    _dataTableApiLogs = appn.dataTable.create('.apiLogsDatatable', {
                        aLengthMenu: [10, 25, 50, 100],
                        aaSorting: [[0, 'desc']],
                        aoColumns: [
                            { sType: 'string' },
                            null,
                            null,
                            null,
                            null
                        ],
                        iDisplayLength: 50
                    });
                }
                function bindDeleteHeaderBtn(btn) {
                    btn.click(function () {
                        const container = $('.headerRowsContainer');
                        $(this).closest('div.headerRow').remove();
                        if (container.children().length === 0) {
                            const wrapper = $('.custom-headers');
                            wrapper.hideElement();
                            $('.add-custom-headers').showElement();
                        }
                    });
                }
                function addSendGridDomain(link) {
                    appn.iframe.openModal({
                        url: link
                    }).then(function ($modal) {
                        $modal.on('hidden.bs.modal', function () {
                            appn.location.reloadCurrentPage();
                        });
                    });
                }
                integrations.addSendGridDomain = addSendGridDomain;
                function showVerifySendGridDomain(link, domainId) {
                    appn.iframe.openModal({
                        url: link + `?domainId=${domainId}`
                    });
                }
                integrations.showVerifySendGridDomain = showVerifySendGridDomain;
                function renameRows() {
                    $(`#sendGridDomainAuthTable tbody tr`).each(function (index) {
                        $(this).find('[id$="DomainId"]')
                            .attr({
                            name: `Provider.ProviderConfig.SendGridDomainAuth[${index}].DomainId`,
                            id: `Provider_ProviderConfig_SendGridDomainAuth_${index}__DomainId`
                        });
                        $(this).find('[id$="DomainName"]')
                            .attr({
                            name: `Provider.ProviderConfig.SendGridDomainAuth[${index}].DomainName`,
                            id: `Provider_ProviderConfig_SendGridDomainAuth_${index}__DomainName`
                        });
                        $(this).find('.domainName')
                            .attr({
                            name: `Provider.ProviderConfig.SendGridDomainAuth[${index}].DomainName`,
                            id: `Provider_ProviderConfig_SendGridDomainAuth_${index}__DomainName`
                        });
                        $(this).find('[id$="Username"]')
                            .attr({
                            name: `Provider.ProviderConfig.SendGridDomainAuth[${index}].Username`,
                            id: `Provider_ProviderConfig_SendGridDomainAuth_${index}__Username`
                        });
                        $(this).find('.username')
                            .attr({
                            name: `Provider.ProviderConfig.SendGridDomainAuth[${index}].Username`,
                            id: `Provider_ProviderConfig_SendGridDomainAuth_${index}__Username`
                        });
                        $(this).find('[id$="CustomDkimSelector"]')
                            .attr({
                            name: `Provider.ProviderConfig.SendGridDomainAuth[${index}].CustomDkimSelector`,
                            id: `Provider_ProviderConfig_SendGridDomainAuth_${index}__CustomDkimSelector`
                        });
                        $(this).find('[id$="BimiImage"]')
                            .attr({
                            name: `Provider.ProviderConfig.SendGridDomainAuth[${index}].BimiImage`,
                            id: `Provider_ProviderConfig_SendGridDomainAuth_${index}__BimiImage`
                        });
                    });
                }
            })(integrations = provider.integrations || (provider.integrations = {}));
        })(provider = views.provider || (views.provider = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
